import { render, staticRenderFns } from "./Tyshxydm.vue?vue&type=template&id=49c51a74&scoped=true&"
import script from "./Tyshxydm.vue?vue&type=script&lang=js&"
export * from "./Tyshxydm.vue?vue&type=script&lang=js&"
import style0 from "./Tyshxydm.vue?vue&type=style&index=0&id=49c51a74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c51a74",
  null
  
)

export default component.exports